import React from 'react';
import PropTypes from 'prop-types';

import {
	Wrapper,
	Text,
	LineWrapper,
	TextWrapper,
} from './barStyles';

import Line from './Line';

const Bar = ({ stars, percentage, slug }) => {
	const url = `/subscription-box/${slug}/reviews/`;
	const href = percentage > 0 ? `${url}?rating=${stars}` : url;
	return (
		<Wrapper href={href}>
			<TextWrapper>
				<Text right >{
					stars > 1
						? `${stars} Stars`
						: `${stars} Star`
				}</Text>
			</TextWrapper>

			<LineWrapper>
				<Line percentage={percentage} />
			</LineWrapper>

			<TextWrapper>
				<Text>{`${Math.round(percentage * 100)}%`}</Text>
			</TextWrapper>
		</Wrapper>
	);
};

Bar.propTypes = {
	stars: PropTypes.number.isRequired,
	percentage: PropTypes.number.isRequired,
	slug: PropTypes.string.isRequired,
};

export default Bar;
